import {
  Uau,
  MandouBem,
  Valeu,
  Colaboracao,
  Inovacao,
  FocoNoCliente,
  Resolutividade,
  Lideranca,
  Selo,
  SeloRealizacao,
} from 'components/icons';
import { useEffect, useMemo, useState } from 'react';
import { format } from 'date-fns';
import { BiGift, BiTrophy, BiMailSend } from 'react-icons/bi';
import { TbMailFast, TbTargetArrow } from 'react-icons/tb';
import { GetTaskLevelLabel } from 'utils/strings';
import { AiOutlineStar } from 'react-icons/ai';
import { getMonthName } from 'services/utils';
import { object } from 'prop-types';
import { FormatNumber } from 'utils/helpers';

const iconSize = 20;
const Coins: any = {
  uau: <Uau yellow size={iconSize} />,
  mandou: <MandouBem yellow size={iconSize} />,
  valeu: <Valeu yellow size={iconSize} />,
};

const CoinLabel: any = {
  uau: 'Arrasou',
  mandou: 'Top',
  valeu: 'Curti',
};

const Behaviors: any = {
  colaboracao: <Colaboracao size={iconSize} />,
  inovacao: <Inovacao size={iconSize} />,
  foco: <FocoNoCliente size={iconSize} />,
  resolutividade: <Resolutividade size={iconSize} />,
  lideranca: <Lideranca size={iconSize} />,
};

const BehaviorLabel: any = {
  colaboracao: 'Colaboração',
  inovacao: 'Inovação',
  foco: 'Foco no Cliente',
  resolutividade: 'Proatividade',
  lideranca: 'Liderança Engajadora',
};

interface PointItemProps {
  data: any;
  cycleLabel?: string;
}

export function PointItem(props: PointItemProps) {
  const { data, cycleLabel } = props;

  const behaviors = function (label?: string) {
    const _label = label || cycleLabel;

    return [
      {
        id: 'colaboracao',
        icon: <Selo size={'124px'} cycle={_label} selo="Colaboracao" />,
        smallIcon: <Selo size={'22px'} cycle={_label} selo="Colaboracao" />,
      },
      {
        id: 'foco',
        icon: <Selo size={'124px'} cycle={_label} selo="Foco" />,
        smallIcon: <Selo size={'22px'} cycle={_label} selo="Foco" />,
      },
      {
        id: 'inovacao',
        icon: <Selo size={'124px'} cycle={_label} selo="Inovacao" />,
        smallIcon: <Selo size={'22px'} cycle={_label} selo="Inovacao" />,
      },
      {
        id: 'resolutividade',
        icon: <Selo size={'124px'} cycle={_label} selo="Resolutividade" />,
        smallIcon: <Selo size={'22px'} cycle={_label} selo="Resolutividade" />,
      },
      {
        id: 'lideranca',
        icon: <Selo size={'124px'} cycle={_label} selo="Lideranca" />,
        smallIcon: <Selo size={'22px'} cycle={_label} selo="Lideranca" />,
      },
    ];
  };

  const galeria = [
    {
      id: 'galeria',
      icon: <Selo selo="Galeria" size={'124px'} cycle={cycleLabel} />,
    },
  ];

  const realizacao_destaque_2S2023 = [
    {
      id: 'realizacao_destaque_2S2023',
      icon: <SeloRealizacao selo="Realizacao" size={'124px'} cycle="2S2023" />,
    },
  ];

  const [origin, setOrigin] = useState<any>();
  const [taskOpened, setTaskOpened] = useState<boolean>(false);

  useEffect(() => {
    const defaultPoint = {
      type: 'default',
      title: 'Crédito de Pontos',
      total: data.total,
      time: data.time,
    };

    try {
      // console.log(typeof data?.log);
      if (typeof data?.log === 'object' || (data?.log && data?.log.length)) {
        let log = typeof data?.log == 'object' ? data.log : data?.log[0];
        setOrigin({
          type: data.extra.type,
          extra: data.extra,
          log,
          total: data.total,
          time: data.time,
        });
      } else if (data.type) {
        setOrigin(data);
      } else {
        setOrigin(defaultPoint);
      }
    } catch (e) {
      setOrigin(defaultPoint);
    }
  }, [data]);

  function getIcon(key?: string, cycle?: string) {
    if (!!key) {
      const icon = behaviors(cycle).filter(item => {
        return item.id === key;
      });

      if (!!icon) {
        return icon[0].smallIcon;
      }
    }
    // console.log(icon);
  }

  function translateTitle(item: any) {
    if (item?.log?.attributes?.campanha) {
      return (
        <>
          <p className="text-gray-300 text-sm font-light mb-3">Campanha</p>
          <p className="block text-base text-alice-blue m-0 font-normal">Você participou {item.log.attributes.campanha}</p>
        </>
      );
    } else if (item?.log?.action === 'Entrou por convite') {
      return (
        <>
          <p className="text-gray-300 text-sm font-light mb-3">Ação</p>
          <p className="block text-base text-alice-blue m-0 font-normal">
            Convide seus amigos - Convite aceito por{' '}
            <span className="text-electric-blue capitalize">{item.extra.target_nome_guerra}</span>
          </p>
        </>
      );
    } else if (item?.log?.attributes?.desafio && item?.log?.attributes?.titulo_desafio) {
      return (
        <>
          <p className="text-gray-300 text-sm font-light mb-3">Desafio</p>
          <p className="block text-base text-alice-blue m-0 font-normal">
            Você participou {item?.log?.attributes?.preposicao ? item?.log?.attributes?.preposicao : 'do'}{' '}
            {item?.log?.attributes?.titulo_desafio}
          </p>
        </>
      );
    } else if (item?.log?.attributes?.type === 'challenge') {
      return (
        <>
          <p className="text-gray-300 text-sm font-light mb-3">Desafio</p>
          <p className="block text-base text-alice-blue m-0 font-normal">{item?.log?.attributes?.title}</p>
        </>
      );
    }
  }

  function getIconCampanha(item: any) {
    if (item?.log?.attributes?.campanha || item?.log?.attributes?.desafio) {
      return <AiOutlineStar className="text-[3rem] text-yellow" />;
    } else if (item?.log?.attributes?.type === 'challenge') {
      return <TbTargetArrow className="text-[3rem] text-yellow" />;
    } else {
      <BiMailSend className="text-[3rem] text-yellow" />;
    }
  }

  return useMemo(() => {
    function renderSeloBB() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:p-7 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex flex-row space-x-3 items-center">
              <div>
                <BiTrophy size={30} className="text-yellow" />
              </div>
              <div className="flex-1">
                Recebeu o Selo em <b className="electric-blue">{origin.log.attributes.selo}</b>
              </div>
            </div>
            <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-2 text-yellow py-1 bg-oxford-blue rounded-full">
                <b>{FormatNumber(origin.total)} pontos</b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderMoedasBonus() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:p-7 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex flex-row space-x-3 items-center">
              <div>
                <BiGift size={30} className="text-yellow" />
              </div>

              <div className="flex-1 text-lg leading-none">
                <p className="font-thin text-sm mb-2">Campanha</p>
                <p className="text-sm">
                  Voce participou do <b className="text-electric-blue">{origin.log.attributes.campanha}</b>
                </p>
              </div>
            </div>

            <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-yellow rounded-full">
                {Behaviors[origin.extra.behavior]} <span className="text-xs">{BehaviorLabel[origin.extra.behavior]}</span>
              </div>

              <div className="flex flex-row items-center space-x-2 px-2 text-yellow py-1 bg-oxford-blue rounded-full">
                <b>+1</b> {Coins[origin.extra.coin]} <span className="text-xs">{CoinLabel[origin.extra.coin]}</span>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderValoracaoGestor() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm">
                  Validação da Realização Destaque - {origin.cicloTitle} - Fase {getMonthName(origin.fase)}
                </p>
                {origin.task ? (
                  <p className="font-thin text-sm mt-1">
                    {origin.task.title}{' '}
                    <button
                      className="font-thin underline hover:no-underline text-electric-blue"
                      onClick={() => setTaskOpened(prevstate => !prevstate)}
                    >
                      {!taskOpened ? 'mais' : 'menos'}
                    </button>
                  </p>
                ) : null}
              </div>

              <div className="text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>

            {taskOpened && typeof origin.task.description === 'string' ? (
              <div>
                <p className="font-normal text-sm text-white">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-white m-1"
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.task.description === 'string'
                        ? origin.task.description.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            ) : null}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderValoracaoGestorFeedback() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm">
                  Feedback enviado nas Realizações Destaque avaliadas - {origin.cicloTitle} - Fase {getMonthName(origin.fase)}
                </p>
              </div>

              <div className="text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderBonusGestorColaboracao() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderBonusGestorPrazo() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm">
                  Bônus por avaliar as realizações dentro do prazo - {origin.cicloTitle} - Fase {getMonthName(origin.fase)}
                </p>
              </div>

              <div className="text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    // function renderEntregaEquipe(isPlublic?: boolean) {
    //   try {
    //     return (
    //       <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
    //         <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-3 md:items-center">
    //           {/* <div>
    //             {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
    //             {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
    //             {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
    //             {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
    //           </div> */}
    //           {/* <div className="flex-1">
    //             <b>{origin.titulo}</b>
    //           </div> */}

    //           <div className="flex-1 text-lg leading-none">
    //             <p className="font-thin text-sm text-gray-300">Nome da realização</p>
    //             <p className="font-bold text-base mt-1 text-gray-500">{origin.titulo}</p>
    //           </div>

    //           <div className="flex-1 text-lg leading-none">
    //             <p className="font-thin text-sm text-gray-300">Fase</p>
    //             <p className="font-bold text-base mt-1 text-gray-500">{origin.faseTitle}</p>
    //           </div>

    //           <div className="flex-1 text-lg leading-none">
    //             <p className="font-thin text-sm text-gray-300">Status da entrega</p>
    //             <p className="font-bold text-base mt-1 text-gray-500">{GetTaskLevelLabel(origin.status)}</p>
    //           </div>

    //           <div className="text-base leading-none">
    //             <p className="font-thin text-sm mb-3 text-gray-300">{isPlublic ? 'Pontos da realização' : 'Atuação'}</p>

    //             <div className="flex">
    //               {origin?.participacao ? (
    //                 <b className="inline-flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none mr-3">
    //                   {origin.participacao}%
    //                   {/* <span className="block font-thin text-[10px] mt-1 uppercase leading-none">
    //                   Participação
    //                 </span> */}
    //                 </b>
    //               ) : null}

    //               {origin?.total ? (
    //                 <b className="flex flex-row items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
    //                   {FormatNumber(origin.total, false)}
    //                   <span className="font-thin text-[10px] mt-1 uppercase leading-none">pts</span>
    //                 </b>
    //               ) : null}
    //             </div>
    //           </div>
    //         </div>

    //         {typeof origin.descricao === 'string' && (
    //           <div>
    //             <p className="font-normal text-sm text-gray-300">Detalhes da realização:</p>
    //             <p
    //               className="font-bold text-base text-gray-500 m-1 "
    //               dangerouslySetInnerHTML={{
    //                 __html:
    //                   typeof origin.descricao === 'string'
    //                     ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
    //                     : '',
    //               }}
    //             />
    //           </div>
    //         )}
    //         {/* <div className="flex flex-row space-x-3 items-center justify-center">
    //           <div className="flex flex-row items-center space-x-2 px-2 text-white py-1 bg-purple rounded-full">
    //             <b>Participação: {origin.participacao}%</b>
    //           </div>
    //           <div className="flex flex-row items-center space-x-2 px-2 text-blue-dark py-1 bg-yellow rounded-full">
    //             <b>+{origin.total} pontos</b>
    //           </div>
    //         </div> */}
    //       </div>
    //     );
    //   } catch (e) {
    //     return null;
    //   }
    // }

    function renderEntregaEquipe(isPlublic?: boolean) {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center" tabIndex={0}>
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm">
                  Participação em Realização Destaque - {origin.cicloTitle} - Fase {origin.faseTitle}
                </p>
                {origin.titulo ? (
                  <p className="font-thin text-sm mt-1">
                    {origin.titulo}{' '}
                    <button
                      className="font-thin underline hover:no-underline text-electric-blue"
                      onClick={() => setTaskOpened(prevstate => !prevstate)}
                    >
                      {!taskOpened ? 'mais' : 'menos'}
                    </button>
                  </p>
                ) : null}
              </div>

              <div className="flex text-base leading-none">
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                {origin?.participacao ? (
                  <b className="inline-flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none mr-3">
                    {origin.participacao}%
                    {/* <span className="block font-thin text-[10px] mt-1 uppercase leading-none">
                      Participação
                    </span> */}
                  </b>
                ) : null}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {FormatNumber(origin.total, false)}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>

            {taskOpened && typeof origin.descricao === 'string' ? (
              <div tabIndex={0}>
                <p className="font-normal text-sm text-white">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-white m-1"
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.descricao === 'string'
                        ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            ) : null}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderDestaqueCultura() {
      return (
        <div className="grid grid-cols-2 items-center gap-8 w-fit rounded-2xl">
          {behaviors()?.map(behavior => (
            <div
              className={`${data?.items?.find((item: any) => item.behavior === behavior.id) ? '' : 'opacity-20'}`}
              key={behavior.id}
            >
              <div>{behavior.icon}</div>
            </div>
          ))}
        </div>
      );
    }

    function renderDestaqueCulturaCondensed() {
      return (
        <div className="grid grid-cols-1 lg:grid-cols-3 items-center lg:gap-8 w-fit rounded-2xl">
          {origin.items
            .filter((item: any) => {
              return !!item.behavior;
            })
            .map((item: any) => (
              <div className="flex flex-row" key={item.behavior}>
                <div className="icon bg-maastricht-blue p-1 h-[30px] w-[30px] mr-1 block rounded-md">
                  {getIcon(item.behavior, item?.cycle)}
                </div>
                <div className="flex flex-col justify-center">
                  {/* <span className="text-grey-dark text-sm lg:text-xs font-medium mb-1">
                    {origin.items[index]?.position}
                  </span> */}
                  <h4 className="text-[#5E7A90] lg:text-[10px] text-base font-normal leading-3">
                    {BehaviorLabel[item.behavior]}
                  </h4>
                </div>
              </div>
            ))}

          {origin.items
            .filter((item: any) => {
              return !item.behavior && !item.type;
            })
            .map((item: any) => (
              <div className="flex flex-row" key={item.behavior + item._id}>
                <div className="icon bg-maastricht-blue p-1 h-[30px] w-[30px] mr-1 block rounded-md">
                  <Selo selo="Galeria" size={22} cycle={cycleLabel ? cycleLabel : item.cycle} />
                </div>
                <div className="flex flex-col justify-center">
                  <h4 className="text-[#5E7A90] lg:text-[10px] text-base font-normal leading-3">Galeria do reconhecimento</h4>
                </div>
              </div>
            ))}

          {origin.items
            .filter((item: any) => {
              return item.type === 'realizacao';
            })
            .map((item: any) => (
              <div className="flex flex-row" key={item.realizacao + item._id}>
                <div className="icon bg-maastricht-blue p-1 h-[30px] w-[30px] mr-1 block rounded-md">
                  <Selo selo="Realizacao" size={22} cycle={cycleLabel ? cycleLabel : item.cycle} />
                </div>
                <div className="flex flex-col justify-center">
                  <h4 className="text-[#5E7A90] lg:text-[10px] text-base font-normal leading-3">Realização Destaque</h4>
                </div>
              </div>
            ))}
        </div>
      );
    }

    function renderGaleria() {
      return (
        <div className="flex items-center space-x-8 w-fit rounded-2xl">
          {galeria.map(galeria => (
            <div className={`${!!data ? '' : 'opacity-20'}`} key={galeria.id}>
              <div>{galeria.icon}</div>
            </div>
          ))}
        </div>
      );
    }
    function renderSeloRealizacao_2S2023() {
      return (
        <div className="flex items-center space-x-8 w-fit rounded-2xl">
          {realizacao_destaque_2S2023.map(realizacao => (
            <div className={`${!!data ? '' : 'opacity-20'}`} key={realizacao.id}>
              <div>{realizacao.icon}</div>
            </div>
          ))}
        </div>
      );
    }

    function renderSeloRealizacao() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-24">
              {/* <div>
                {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
                {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
                {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
                {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
              </div> */}
              {/* <div className="flex-1">
                <b>{origin.titulo}</b>
              </div> */}

              <div className="flex-1 text-lg leading-none">
                <p className="font-bold text-base text-gray-300">Nome da realização</p>
                <p className="font-thin text-sm mt-1 text-gray-500">{origin.titulo}</p>
              </div>

              <div className="font-bold text-base leading-none">
                <p className="font-bold text-base mb-3 text-gray-300">Pontuação da realização</p>

                <div className="flex">
                  {origin?.total ? (
                    <b className="flex flex-row items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                      {FormatNumber(origin.total, false)}
                    </b>
                  ) : null}
                </div>
              </div>

              <div className="text-lg leading-none">
                <p className="font-bold text-base mb-3 text-gray-300">Selo conquistado</p>

                <div className="mt-1 flex justify-center">
                  <Selo selo="Realizacao" size={70} cycle={cycleLabel} />
                </div>
              </div>
            </div>

            {typeof origin.descricao === 'string' && (
              <div>
                <p className="font-bold text-base text-gray-300">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-gray-500 m-1 "
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.descricao === 'string'
                        ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            )}
            {/* <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-2 text-white py-1 bg-purple rounded-full">
                <b>Participação: {origin.participacao}%</b>
              </div>
              <div className="flex flex-row items-center space-x-2 px-2 text-blue-dark py-1 bg-yellow rounded-full">
                <b>+{origin.total} pontos</b>
              </div>
            </div> */}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderRealizacaoColetiva() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-24">
              {/* <div>
                {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
                {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
                {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
                {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
              </div> */}
              {/* <div className="flex-1">
                <b>{origin.titulo}</b>
              </div> */}

              <div className="flex-1 text-lg leading-none">
                <p className="font-bold text-base text-gray-300">Nome da realização</p>
                <p className="font-thin text-sm mt-1 text-gray-500">{origin.title}</p>
              </div>

              <div className="flex-1 text-lg leading-none">
                <p className="font-bold text-base text-gray-300">Fase</p>
                <p className="font-thin text-sm mt-1 text-gray-500">{origin.fase}</p>
              </div>

              <div className="flex-1 text-lg leading-none">
                <p className="font-bold text-base text-gray-300">Status da entrega</p>
                <p className="font-thin text-sm mt-1 text-gray-500">{origin.status}</p>
              </div>

              <div className="text-base leading-none">
                <p className="font-bold text-base mb-3 text-gray-300">Pontuação da realização</p>

                <div className="flex">
                  {origin?.total ? (
                    <b className="flex flex-row items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                      {FormatNumber(origin.total, false)}
                    </b>
                  ) : null}
                </div>
              </div>
            </div>

            {typeof origin.description === 'string' && (
              <div>
                <p className="font-bold text-base text-gray-300">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-gray-500 m-1 "
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.description === 'string'
                        ? origin.description.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            )}
            {/* <div className="flex flex-row space-x-3 items-center justify-center">
              <div className="flex flex-row items-center space-x-2 px-2 text-white py-1 bg-purple rounded-full">
                <b>Participação: {origin.participacao}%</b>
              </div>
              <div className="flex flex-row items-center space-x-2 px-2 text-blue-dark py-1 bg-yellow rounded-full">
                <b>+{origin.total} pontos</b>
              </div>
            </div> */}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderRealizacaoPremiada() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-24">
              {/* <div>
                {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
                {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
                {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
                {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
              </div> */}
              {/* <div className="flex-1">
                <b>{origin.titulo}</b>
              </div> */}

              <div className="flex-1 text-lg leading-none">
                <p className="font-bold text-base text-gray-300">Nome da realização</p>
                <p className="font-thin text-sm mt-1 text-gray-500">
                  {origin?.task?.title ? origin?.task?.title : origin.titulo}
                </p>
              </div>
            </div>

            {(typeof origin.descricao === 'string' || typeof origin?.task?.description === 'string') && (
              <div>
                <p className="font-bold text-base text-gray-300">Detalhes da realização:</p>
                <p
                  className="font-thin text-sm text-gray-500 m-1 "
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin?.task?.description === 'string'
                        ? origin.task.description.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;'),
                  }}
                />
              </div>
            )}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderDefault() {
      return (
        <div
          className="flex flex-col lg:flex-row lg:items-center lg:justify-between bg-maastricht-blue-3 p-3 lg:py-10 lg:px-16 space-y-5 lg:space-y-0 lg:space-x-3 rounded-xl"
          tabIndex={0}
        >
          <div className="flex flex-row space-x-3 items-center">
            <div>{getIconCampanha(origin)}</div>
            <div className="flex-1">{translateTitle(origin)}</div>
          </div>
          <div className="flex flex-row space-x-3 items-center justify-center">
            <div className="flex flex-row items-center space-x-2 px-3 bg-oxford-blue py-1 text-yellow rounded-full">
              <b>{FormatNumber(origin.total, false)} pontos</b>
            </div>
          </div>
        </div>
      );
    }

    if (!origin) return null;

    switch (origin.type) {
      case 'moedas_bonus':
        return renderMoedasBonus();
      case 'selobb':
        return renderSeloBB();
      case 'destaque_cultura':
        return renderDestaqueCultura();
      case 'destaque_cultura_condensed':
        return renderDestaqueCulturaCondensed();
      case 'entrega_equipe':
        return renderEntregaEquipe();
      case 'entrega_equipe_public':
        return renderEntregaEquipe(true);
      case 'entrega_gestor':
        return renderValoracaoGestor();
      case 'feedback_gestor':
        return renderValoracaoGestorFeedback();
      case 'bonus_colaboracao_gestor':
        return renderBonusGestorColaboracao();
      case 'pontos_bonus_prazo_gestor':
        return renderBonusGestorPrazo();
      case 'galeria':
        return renderGaleria();
      case 'selo_realizacao_2S2023':
        return renderSeloRealizacao_2S2023();
      case 'selo_realizacao':
        return renderSeloRealizacao();
      case 'realizaca_premiada_coletiva':
        return renderRealizacaoColetiva();
      case 'realizaca_premiada':
        return renderRealizacaoPremiada();
      default:
        return renderDefault();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [origin, taskOpened, behaviors, data, cycleLabel, galeria]);
}
